import { withStyles } from '@aura/components/styles'
import classnames from 'classnames'
import flatten from 'lodash/fp/flatten'
import initial from 'lodash/fp/initial'
import map from 'lodash/fp/map'
import PropTypes from 'prop-types'
import React from 'react'
import Notification from './components/notification'
import styles from './styles'
import { NotificationType } from './types'


class NotificationsComponent extends React.Component {

    static displayName = 'Notifications'

    static propTypes = {
        classes: PropTypes.shape({
            root: PropTypes.string.isRequired,
            spacer: PropTypes.string.isRequired
        }).isRequired,
        className: PropTypes.string,
        notifications: PropTypes.arrayOf(NotificationType).isRequired,
        removeNotification: PropTypes.func.isRequired
    }

    render() {

        const { props } = this
        const { classes } = props

        return (
            <div className={classnames(props.className, classes.root)}>
                {initial(flatten(map(notification => [
                    <Notification
                        key={notification.id}
                        notification={notification}
                        onRemove={props.removeNotification}
                    />,
                    <div className={classes.spacer} key={`spacer-${notification.id}`} />
                ], props.notifications)))}
            </div>
        )
    }
}

export default withStyles(NotificationsComponent, styles)